import { Record } from 'immutable';

import { Question } from './Question';

class Conversation extends Record(
  {
    id: null,
    userId: null,
    scriptId: null,
    conversationId: null,
    organizationId: null,
    assetQuestionId: null,
    title: null,
    summary: null,
    type: null,
    analystInvited: false,
    createdAt: null,
    updatedAt: null,
    deletedAt: null,
    createdBy: null,
    updatedBy: null,
    deletedBy: null,
    shares: [],
    assetQuestion: null
  },
  'Conversation'
) {
  constructor(props) {
    super({
      ...props,
      assetQuestion: props?.assetQuestion ? new Question(props.assetQuestion) : null
    });
  }

  get isShared() {
    return this.shares?.length > 0;
  }

  isSharedWith(user, users) {
    return (
      this.shares?.length > 0 && user?.sub !== users.find((u) => u.id === this.userId)?.auth0Id
    );
  }

  sharedBy(currentUser, allUsers) {
    if (this.createdBy === currentUser?.id) {
      return null;
    }

    return allUsers.find((u) => u.id === this.userId);
  }

  get displayTitle() {
    if (this?.title) {
      return this.title;
    }
    return 'New conversation';
  }
}

export { Conversation };
